import { Outlet, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { verifyToken } from "../redux/actions/authActions";
import Loader from "../components/common/Loader";
import { isAuthenticated } from "../redux/selectors/authSelector";

const PrivateRoute = () => {
  const dispatch = useDispatch();
  const auth = useSelector(isAuthenticated);

  useEffect(() => {
    const token = localStorage.getItem("authorizationToken");
    if (token && !auth) {
      dispatch(verifyToken());
    }
  }, [auth, dispatch]);

  if (!auth && localStorage.getItem("authorizationToken")) {
    return <Loader isClass="loader_fullscreen" />;
  }

  if (!auth) {
    return <Navigate to="/" replace />;
  }

  // 🔥 THIS IS THE FIX
  return <Outlet />;
};

export default PrivateRoute;
